import { ProductListing } from "../../src/pages/dxPages/ProductListing";
import { ProductListingNotFound } from "../../src/pages/dxPages/ProductListingNotFound";
import HeaderTotalCartItems from "../../src/pages/dxPages/HeaderTotalCartItems";
import UniversalSearch from "../../src/pages/dxPages/UniversalSearch";
import { ProductDetail } from "../../src/pages/dxPages/ProductDetail";
import { ProductCompare } from "../../src/pages/dxPages/ProductCompare";
import ProductCompareMiniSlider from "../../src/pages/ProductCompare/BottomCompareProduct/ProductCompareMiniSlider";
import { Cart } from "../../src/pages/dxPages/Cart";
import { Checkout } from "../../src/pages/dxPages/Checkout";
import { Quote } from "../../src/pages/dxPages/Quote";
import { ProductListingMobile } from "../../src/pages/ProductListing/ProductListingMobile";
import Product from "@system/config/product";
import ProductCompareConfig from "@system/config/product-compare";
import CheckOut from "@system/config/checkout";
import CartConfig from "@system/config/cart";
import QuoteConfig from "@system/config/quote";
import BomConfig from "@system/config/bom";
import OrderConfig from "@system/config/order";
import { BOM } from "src/pages/dxPages/BOM";
import { Order } from "src/pages/dxPages/Order";
import Profile from "src/pages/dxPages/Profile";
import { HomePageContent } from "src/pages/HomePageContent/HomePageContent";
import SuccessCheckout from "src/pages/dxPages/SuccessCheckout";
import Constants from "src/helper/Constants";
import AdminConfig from "@system/config/admin";
import UserManagementTab from "src/pages/dxPages/UserManagementTab";
import UserDetail from "src/pages/dxPages/UserDetail";
import AccountDetail from "src/pages/dxPages/AccountDetail";
import Registration from "src/pages/dxPages/Registration";
import ProfileConfig from "@system/config/profile";
import LinkToExistingAccount from "src/pages/Profile/LinkToExistingAccount";
import BomManagementTab from "src/pages/dxPages/BomManagementTab";
import ComplianceManagementTab from "src/pages/dxPages/ComplianceManagementTab";
import { AdminBomDetailsList } from "src/pages/dxPages/AdminBomDetailsList";
import OrderAdmin from "src/pages/dxPages/OrderAdmin";
import OrderInsight from "src/pages/dxPages/OrderInsight";
import QuoteCart from "src/pages/QuoteDetail/QuoteCart";

class MicroComponents {
    // Note: name should be as componentName

    static chain = [
        { name: 'ProductListing', element: ProductListing, url: Product.getProductListingPageRouteURL() },
        { name: 'ProductListingNotFound', element: ProductListingNotFound, url: Product.getProductListingNotFoundPageRouteURL() },
        { name: 'ProductDetail', element: ProductDetail, url: Product.getProductDetailPageRouteURL() },
        { name: 'ProductCompare', element: ProductCompare, url: ProductCompareConfig.getProductComparePageRouteURL() },
        { name: 'Checkout', element: Checkout, url: CheckOut.getCheckOutRouteURL() },
        { name: 'Cart', element: Cart, url: CartConfig.getCartPageRouteURL() },
        { name: 'SuccessCheckout', element: SuccessCheckout, url: CheckOut.getCheckOutStatusRouteURL() },
        { name: 'SuccessCheckoutQuote', element: SuccessCheckout, url: CheckOut.getCheckOutStatusRouteURL(Constants.systemModules.Quote) },
        { name: 'Quote', element: Quote, url: QuoteConfig.getQuoteRouteURL() },
        { name: 'Bom', element: BOM, url: BomConfig.getBomRouteURL() },
        { name: 'Order', element: Order, url: OrderConfig.getOrderRouteURL() },
        /// // Non-URL based components
        { name: 'HeaderTotalCartItems', element: HeaderTotalCartItems },
        { name: 'ProductCompareMiniSlider', element: ProductCompareMiniSlider },
        { name: 'ProductListingMobile', element: ProductListingMobile },
        { name: 'UniversalSearch', element: UniversalSearch },
        { name: 'Profile', element: Profile, url: ProfileConfig.getProfileURL() },
        { name: 'LinkToExistingAccount', element: LinkToExistingAccount, url: ProfileConfig.getLinkToExistingAccountURL()},
        { name: 'HomePageContent', element: HomePageContent },
        { name: 'UserManagementTab', element: UserManagementTab, url: AdminConfig.getAdminURL() },
        { name: 'UserDetail', element: UserDetail, url: AdminConfig.getUserDetailURL() },
        { name: 'AccountDetail', element: AccountDetail, url: AdminConfig.getAccountDetailURL() },
        { name: 'Registration', element: Registration, url: AdminConfig.getRegistrationURL() },
        { name: 'BomManagementTab', element: BomManagementTab,url: AdminConfig.getBomManagerURL()  },
        { name: 'ComplianceManagementTab', element:ComplianceManagementTab ,url: AdminConfig.getComplianceManagerURL()  },
        { name: 'AdminBomDetailsList', element: AdminBomDetailsList,url: AdminConfig.getBomManagerDetailsURL()  },
        { name: 'OrderAdmin', element: OrderAdmin, url: AdminConfig.getAdminOrderURL() },
        { name: 'OrderInsight', element: OrderInsight, url: AdminConfig.getAdminOrderInsightURL() },
        { name: 'QuoteCart', element: QuoteCart, url: QuoteConfig.getQuoteCartRouteURL() },
    ];
}

export default MicroComponents;